import { Box, Typography } from '@mui/material'
import { toPng } from 'html-to-image'
import { useEffect, useRef } from 'react'
import { Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import { myI18n } from 'translation/I18nConnectedProvider'
import './ImportanceChart.css'

const colors = {
  governance: { fill: '#49BAD7', label: 'Governance' },
  property: { fill: '#0A8646', label: 'Property' },
  financial: { fill: '#17374F', label: 'Financial' },
  social: { fill: '#9AC765', label: 'Social' }
}

export const getChartData = (score, skippedSections) => {
  if (!score) return []

  const validKeys = Object.keys(score.sections).filter(
    section => !skippedSections?.includes(section) && colors[section]
  )
  const totalWeights = validKeys
    .map(section => score.sections[section].weight)
    .reduce((curr, prev) => curr + prev, 0)

  return validKeys.map(section => ({
    importance: totalWeights
      ? Math.floor((score.sections[section].weight / totalWeights) * 100)
      : +Number(100 / validKeys.length).toFixed(),
    fill: colors[section].fill,
    label: myI18n._(colors[section].label)
  }))
}

export const ImportanceChart = ({
  data,
  score,
  skippedSections = [],
  width = 400,
  height = 400,
  classes,
  onImageGenerated,
  language,
  setChartPayload
}) => {
  const chartRef = useRef(null)
  const chartPayload = data?.map(item => ({
    color: item.fill,
    value: item.label
  }))

  // Function to generate the image from the chart
  const generateImage = async () => {
    if (chartRef.current) {
      try {
        const image = await toPng(chartRef.current, {
          backgroundColor: 'white',
          pixelRatio: 3
        })
        if (image && onImageGenerated) {
          onImageGenerated(image)
        }
      } catch (error) {
        console.error('Error generating image:', error)
      }
    }
  }

  // Trigger image generation on component mount (after rendering)
  useEffect(() => {
    generateImage()
  }, [score, language])

  return (
    <Box
      className='chart-container'
    >
      <Box className='legend-container'>
        {chartPayload?.map((entry, index) => (
          <Box key={index} className='row'>
            <Box
              className='color-box'
              sx={{
                backgroundColor: entry.color
              }}
            />
            <Typography className='text'>
              {entry.value}
            </Typography>
          </Box>
        ))}
      </Box>
      <ResponsiveContainer width={300} height={270} ref={chartRef}>
        <PieChart>
          <Tooltip />
          <Pie
            isAnimationActive={false}
            data={data}
            label
            cx='50%'
            cy='50%'
            outerRadius={100}
            dataKey='importance'
            nameKey='label'
          />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  )
}
